import { useTranslation } from "react-i18next";
import { getTaskCounts } from "../api";
import { useStore } from "../store";
import TasksView from "./TasksView";

// Embedded task list for a record detail page (candidate / project / client). New tasks are
// pre-linked to that record; the link pickers are hidden.
export default function TasksPanel({ candidateId, projectId, clientId }) {
  const { t } = useTranslation("Veft");
  const setTaskNavBadge = useStore((s) => s.setTaskNavBadge);

  const link = candidateId ? { candidateId } : projectId ? { projectId } : { clientId };

  return (
    <TasksView
      fetchParams={link}
      presetLink={link}
      showLinks={false}
      emptyMessage={t("tasks_empty_panel")}
      onChanged={() => getTaskCounts().then((c) => setTaskNavBadge(c?.navBadge ?? 0)).catch(() => {})}
    />
  );
}
